/**
 * 쿼리챌린지(001) 채점의 **결과 비교 규칙 — 한 곳**(2026-10-05).
 *
 * 채점(ParticipationTab)과 「평가 기준」 창(QueryRubricDialog)이 같은 상수를 본다 — 창에 숫자를 따로 적으면
 * 채점이 바뀔 때 창만 남아 거짓말을 한다. 샘플 검증기(`scripts/verify-sample-challenges.js`)도 이 규칙을 그대로 따라 한다
 * (Node 라 이 파일을 불러올 수 없어 같은 상수를 적어 두었다 — 바꾸면 거기도 바꿀 것).
 *
 * 정답 = **정답 SQL 의 결과와 같다**:
 *   ① 처음 COMPARE_ROWS(10)행이 값까지 같다 — 컬럼 이름(별칭)·컬럼 순서·행 순서·값(대소문자 포함)
 *   ② 가져온 행 수가 같다(최대 FETCH_ROWS(50)행까지 센다) — ①만 보면 11행째부터 더 내거나 덜 내는 답이
 *      정답이 됐다(2026-10-05 평가 기준 정리에서 찾음)
 * 날짜는 같은 순간이면 표기가 달라도 같다고 본다(ISO 문자열 정규화).
 */

/** 값까지 견주는 행 수 */
export const COMPARE_ROWS = 10;
/** 결과를 가져오는 행 수 — 행 수 비교는 여기까지 센다 */
export const FETCH_ROWS = 50;

const ISO_DATE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

/** ISO 날짜 문자열을 같은 표기로 — 같은 순간이 다르게 찍혀 오답이 되지 않게 */
export function normalizeDateFields(rows) {
  return (rows || []).map((row) => {
    const out = { ...row };
    for (const k of Object.keys(out)) {
      if (typeof out[k] === 'string' && ISO_DATE.test(out[k])) {
        const d = new Date(out[k]);
        if (!Number.isNaN(d.getTime())) out[k] = d.toISOString();
      }
    }
    return out;
  });
}

/**
 * 제출 결과와 정답 결과를 견준다.
 * @returns {{ correct: boolean, sameTop: boolean, userCount: number, answerCount: number, user: object[], answer: object[] }}
 *   user/answer 는 비교에 쓴 처음 COMPARE_ROWS 행(정규화 후) — 오답 상세 분석에 그대로 쓴다
 */
export function compareQueryResult(userRows, answerRows) {
  const user = normalizeDateFields((userRows || []).slice(0, COMPARE_ROWS));
  const answer = normalizeDateFields((answerRows || []).slice(0, COMPARE_ROWS));
  const sameTop = JSON.stringify(user) === JSON.stringify(answer);
  const userCount = Math.min((userRows || []).length, FETCH_ROWS);
  const answerCount = Math.min((answerRows || []).length, FETCH_ROWS);
  return { correct: sameTop && userCount === answerCount, sameTop, userCount, answerCount, user, answer };
}
